// extracted by mini-css-extract-plugin
module.exports = {"component":"ScrollToTop_component__1cbq_","show":"ScrollToTop_show__CAgp3","fadeIn":"ScrollToTop_fadeIn__0DEQY"};